import { render, staticRenderFns } from "./ErrorMyProfileUpdateUser.vue?vue&type=template&id=22112293&"
import script from "./ErrorMyProfileUpdateUser.vue?vue&type=script&lang=js&"
export * from "./ErrorMyProfileUpdateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports